export const BRANCH_NAME = 'test-branch'
export const PROJECT_ID = 'test-project'
